// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.DisplayMarketplace-module_imageContainer___noI84 {
  flex-shrink: 0;
  width: 16px;
  aspect-ratio: 1/1;
}
.DisplayMarketplace-module_imageContainer___noI84 img {
  height: 100%;
  width: 100%;
  object-fit: contain;
  display: block;
}`, "",{"version":3,"sources":["webpack://./src/components/displayMarketplace/DisplayMarketplace.module.scss"],"names":[],"mappings":"AAAA;EACC,cAAA;EACA,WAAA;EACA,iBAAA;AACD;AACC;EACC,YAAA;EACA,WAAA;EACA,mBAAA;EACA,cAAA;AACF","sourcesContent":[".imageContainer {\r\n\tflex-shrink: 0;\r\n\twidth: 16px;\r\n\taspect-ratio: 1/1;\r\n\r\n\timg {\r\n\t\theight: 100%;\r\n\t\twidth: 100%;\r\n\t\tobject-fit: contain;\r\n\t\tdisplay: block;\r\n\t}\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"imageContainer": `DisplayMarketplace-module_imageContainer___noI84`
};
export default ___CSS_LOADER_EXPORT___;
